import {removeCookie} from "react-use-cookie";
import {configureStore} from "@reduxjs/toolkit";

import {instance, setNavigateFunction} from "../api/apiSetup";
import devIT from "../Components/DevIT/DevITSlice";
import finBlock from "../Components/FinBlock/FinBlockSlice";
import finSettings from "../Components/FinBlock/FinSettings/FinSettingsSlice";
import kpf from "../Components/KP/kp-f/KpFinSlice";
import logistCargos from "../Components/Logist/redux/Cargos/CargosSlice";
import logistCarriers from "../Components/Logist/redux/Carriers/CarriersSlice";
import logist from "../Components/Logist/redux/LogistSlice";
import logistReminders from "../Components/Logist/redux/Reminders/RemindersSlice";
import logistWarehouses from "../Components/Logist/redux/Warehouses/WarehousesSlice";
import projects from "../Components/Project/ProjectSlice";
import reminds from "../Components/reminder/RemindsSlice";
import proforms from "../Components/Requests/Proform/redux/slices/ProformSlice";
import payment from "../Components/Requests/RequestsInProgress/modalsInProgress/modalPaymentDocParts/redux/PaymentOperationsSlice";
import requests from "../Components/Requests/RequestsSlice";
import sku from "../Components/SKU/SkuSlice";
import system from "../Components/System/SystemSlice";
import todoStore from "../Components/TodoRow/todoSlice";
import brandDiscounts from "../Components/VED/redux/slices/BrandDiscountSlice";
import factories from "../Components/VED/redux/slices/FactorySlice";
import vedSettings from "../Components/VED/VedSetiingsGeneral/VedSettingsSlice";
import warehouse from "../Components/Warehouse/WarehouseSlice";
import catalogs from "../slices/CatalogsSlice";
import kp from "../slices/KPSlice";
import person from "../slices/PersonSlice";
import user, {setNotAuth} from "../slices/UserSlice";

const stringMiddleware = () => next => action => {
  if (typeof action === "string") {
    return next({
      type: action,
    });
  }
  return next(action);
};

const store = configureStore({
  reducer: {
    user,
    projects,
    catalogs,
    kp,
    reminds,
    person,
    sku,
    kpf,
    requests,
    proforms,
    payment,
    factories,
    logist,
    logistCarriers,
    logistWarehouses,
    logistReminders,
    logistCargos,
    finSettings,
    devIT,
    finBlock,
    brandDiscounts,
    vedSettings,
    todoStore,
    system,
    warehouse,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(stringMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error?.response?.status === 401) {
      store.dispatch(setNotAuth());
      setNavigateFunction("/login");
      removeCookie("access_token");
      localStorage.removeItem("login_time");
      // sessionStorage.removeItem('access_token')
      return Promise.reject(error);
    } else {
      throw error;
    }
  },
);
